import type { ProFormColumnsType } from '@ant-design/pro-components';
import type { BaseFormSchemaProps } from '@pages/BtlApplicationFormPage/types';
import type { MessageKeys } from '@app-types/intl';

type OoPropertyOutgoingsFormSchemaProps = Pick<BaseFormSchemaProps, 'formatMessage'>;

function createMonthlyMoneyField(
  formatMessage: OoPropertyOutgoingsFormSchemaProps['formatMessage'],
  labelKey: MessageKeys,
  dataIndex: string[],
  options?: { required?: boolean },
): ProFormColumnsType {
  return {
    title: formatMessage({ id: labelKey }),
    dataIndex,
    valueType: { type: 'money', locale: 'en-GB' },
    width: 300,
    fieldProps: {
      precision: 0,
      placeholder: '£',
      suffix: 'monthly',
    },
    // No `hasFeedback` here: its validation-status icon takes the input's suffix slot and hides the
    // 'monthly' hint. The error message under the field is enough to convey the failure.
    formItemProps: options?.required
      ? {
          rules: [
            {
              required: true,
              type: 'number',
              min: 0,
              message: formatMessage({ id: 'common.error.requiredField' }),
            },
          ],
        }
      : undefined,
  };
}

export function ooPropertyOutgoingsFormSchema(props: OoPropertyOutgoingsFormSchemaProps): ProFormColumnsType[] {
  const { formatMessage } = props;

  return [
    {
      renderFormItem: () => (
        <h3 className='mb-1'>{formatMessage({ id: 'ooCase.property.propertyOutgoings.header' })}</h3>
      ),
    },
    createMonthlyMoneyField(formatMessage, 'ooCase.property.councilTax.label', ['propertyOutgoings', 'councilTax'], {
      required: true,
    }),
    createMonthlyMoneyField(formatMessage, 'ooCase.property.serviceChargeGroundRent.label', [
      'propertyOutgoings',
      'serviceChargeGroundRent',
    ]),
  ];
}
